<template>
  <svg
    id="icon-chevron-down"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 9 6"
    :fill="fill"
  >
    <path
      d="M4.88086 5.38818C4.77246 5.38818 4.67139 5.36621 4.57764 5.32227C4.48682 5.28125 4.39746 5.21533 4.30957 5.12451L1.05762 1.80664C0.922852 1.67188 0.855469 1.50781 0.855469 1.31445C0.855469 1.18848 0.887695 1.07129 0.952148 0.962891C1.01367 0.854492 1.09717 0.768066 1.20264 0.703613C1.30811 0.64209 1.42529 0.611328 1.5542 0.611328C1.74756 0.611328 1.92041 0.686035 2.07275 0.835449L4.88525 3.73145L7.69336 0.835449C7.83984 0.686035 8.01123 0.611328 8.20752 0.611328C8.33643 0.611328 8.45361 0.64209 8.55908 0.703613C8.66455 0.768066 8.74805 0.854492 8.80957 0.962891C8.87402 1.07129 8.90625 1.18848 8.90625 1.31445C8.90625 1.50781 8.84033 1.67188 8.7085 1.80664L5.45654 5.12451C5.36865 5.21533 5.27783 5.28125 5.18408 5.32227C5.09326 5.36328 4.99219 5.38525 4.88086 5.38818Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconChevronDown",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
